<template>
  <div class="app app--wide">
    <nav class="top-nav">
      <button
        class="nav-link"
        :class="{ active: activeTab === 'medical' }"
        @click="activeTab = 'medical'"
      >
        Medical Providers
      </button>
      <button
        class="nav-link"
        :class="{ active: activeTab === 'general' }"
        @click="activeTab = 'general'"
      >
        General Providers
      </button>
    </nav>
    <main class="main">
      <ProvidersTable v-show="activeTab === 'medical'" />
      <GeneralProvidersTable v-show="activeTab === 'general'" />
    </main>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars, import/extensions */
import { ref } from 'vue';
import ProvidersTable from './ProvidersTable.vue';
import GeneralProvidersTable from './GeneralProvidersTable.vue';

const activeTab = ref('medical');
</script>

<style>
.app {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  font-family: system-ui, sans-serif;
  transition: max-width 0.2s ease;
}

.app.app--wide {
  max-width: 1200px;
}

.top-nav {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.nav-link {
  flex: 1;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #49454f;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.nav-link:hover {
  background: #f5f5f5;
  color: #1c1b1f;
}

.nav-link.active {
  background: linear-gradient(
  135deg,
  #1e90c815 0%,
  #2babe215 25%,
  #5fc7ea15 50%,
  #7fe0ff15 75%,
  #a6ecff15 100%
);
  color: #1c1b1f;
  font-weight: 600;
  border-bottom: 2px solid #2babe2;
}

.main {
  min-height: 200px;
}
</style>
